import { Component, OnInit, Input, Output, TemplateRef, ViewChild, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';

import { S1AutocompleteService, IS1AutocompleteResult } from '../s1-autocomplete.service';
import { IS1StandardSearchModalConfig } from '../s1-standard-search-modal/s1-standard-search-modal.component';
import { IS1RicercaStandardResult } from '../s1-standard-search.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/public_api';

export interface IS1InputAutocompleteConfig {
  pathAutocomplete: string,
  standardSearch?: IS1StandardSearchModalConfig
}

@Component({
    selector: 's1-input-autocomplete',
    templateUrl: './s1-input-autocomplete.component.html',
    styleUrls: ['./s1-input-autocomplete.component.scss'],
    standalone: false
})
export class S1InputAutocomplete implements OnInit {

  @Input() config: IS1InputAutocompleteConfig;
  @Input() control: UntypedFormControl;
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() isValid: boolean = true;
  @Input() readonly: boolean = false;
  @Input() withButtonList: boolean = true;
  @Output() elementSelected = new EventEmitter<IS1AutocompleteResult>();

  dataSource: Observable<any>
  public template: TemplateRef<any>

  constructor(private utenteService: S1AutocompleteService) { }

  ngOnInit(): void {

    this.dataSource = Observable.create(observer => { 
      this.utenteService.autocomplete(this.config.pathAutocomplete, ""+this.control?.value).subscribe(results => {
        observer.next(results)
      })
    })

  }

  changeTypeaheadLoading(element: TypeaheadMatch) { }
  
  changeTypeaheadNoResults(element: TypeaheadMatch) { }
   
  typeaheadOnSelect(element: TypeaheadMatch) {

    this.elementSelected.emit(element.item)

  }

  elementSelectedOnStandardSearchModal(element: IS1RicercaStandardResult) {

    this.control.patchValue(element.codice)
    this.elementSelected.emit(element)

  }

}
